export function formatEstimate(num) {
  return num === 0
    ? 0
    : num.replace(".", "").replace(",", ".").replace(".", ",");
}
